(() => {
  if (window.asCartStockInitialized) return;
  window.asCartStockInitialized = true;
  let adding = false;

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-as-stock-variant]');
    if (!select) return;
    const card = select.closest('[data-as-stock-card]');
    const option = select.selectedOptions[0];
    const button = card.querySelector('.as-cart-cross__add');
    button.dataset.asVariantId = option.value;
    button.dataset.asQuantity = option.dataset.quantity || '1';
    button.disabled = !option.value || adding;
    card.querySelector('[data-as-stock-price]').innerHTML = option.dataset.price;
    card.querySelectorAll('a').forEach((link) => { link.href = option.dataset.url; });
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-as-stock-card] .as-cart-cross__add');
    if (!button || button.disabled || adding || !button.dataset.asVariantId) return;
    event.preventDefault();
    adding = true;
    button.classList.add('is-loading');
    const error = button.closest('[data-as-stock-card]').querySelector('[role="alert"]');
    error.hidden = true;
    document.querySelectorAll('[data-as-stock-card] button').forEach((b) => { b.disabled = true; });
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.asVariantId), quantity: Number(button.dataset.asQuantity || 1) }],
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || window.asCartStockError);
      const drawer = document.querySelector('cart-drawer');
      if (drawer && result.sections?.['cart-drawer']) {
        drawer.renderContents(result);
      } else {
        window.location.assign(root + 'cart');
      }
    } catch (err) {
      error.textContent = err.message || window.asCartStockError;
      error.hidden = false;
    } finally {
      adding = false;
      button.classList.remove('is-loading');
      document.querySelectorAll('[data-as-stock-card] .as-cart-cross__add').forEach((b) => {
        b.disabled = !b.dataset.asVariantId;
      });
    }
  });
})();
